



























import { Component, Prop, Vue } from 'vue-property-decorator';
import ICountUp from 'vue-countup-v2';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';

@Component ({
  components: {
      ICountUp
  },
})
export default class extends Vue {
    countDuration: number = 1.0;

    totalCount: number = 0;
    averageCount: number = 0;

    minimumCount: number = 0;
    maximumCount: number = 0;

    minDate: string = "";
    maxDate: string = "";

    periodStart: string = "";
    periodEnd: string = "";

    created() {
        let dataSet: VisitorsRecord[] = FView.Get().dataManager.GetDataset(DataType.VisitorsDaily);
        this.totalCount = dataSet.flatMap(r => r.visitors).reduce((prev, cur) => { return prev + cur; });
        this.averageCount = this.totalCount / dataSet.length;
        
        let minRecord = dataSet.reduce((prev, cur) => { return prev.visitors <= cur.visitors ? prev : cur; });
        let maxRecord = dataSet.reduce((prev, cur) => { return prev.visitors >= cur.visitors ? prev : cur; });

        this.minimumCount = minRecord.visitors;
        this.maximumCount = maxRecord.visitors;

        this.minDate = Common.FormatDate(minRecord.stat_date);
        this.maxDate = Common.FormatDate(maxRecord.stat_date);

        this.periodStart = Common.FormatDate(FView.Get().dataManager.GetCurrentRange().start);
        this.periodEnd = Common.FormatDate(FView.Get().dataManager.GetCurrentRange().end);
    }
}
